module.exports = __webpack_public_path__ + "img/ic_android_link_tip.3b55a64f.png";